"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(wrapMultiple),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(wrapForMethod),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(wrapForMethodRaw),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(resolveAndWrap);

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAndWrap = exports.wrapForMethod = exports.wrapMultiple = exports.Messages = exports.wrap = exports.BadResponseTypeError = exports.TypeMismatchError = exports.NoUniqueBestOverloadError = exports.NoOverloadsMatchedError = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:wrap");

var priority_1 = require("./priority");

var errors_1 = require("./errors");

Object.defineProperty(exports, "NoOverloadsMatchedError", {
  enumerable: true,
  get: function get() {
    return errors_1.NoOverloadsMatchedError;
  }
});
Object.defineProperty(exports, "NoUniqueBestOverloadError", {
  enumerable: true,
  get: function get() {
    return errors_1.NoUniqueBestOverloadError;
  }
});
Object.defineProperty(exports, "TypeMismatchError", {
  enumerable: true,
  get: function get() {
    return errors_1.TypeMismatchError;
  }
});
Object.defineProperty(exports, "BadResponseTypeError", {
  enumerable: true,
  get: function get() {
    return errors_1.BadResponseTypeError;
  }
});

__exportStar(require("./errors"), exports);

var wrap_1 = require("./wrap");

Object.defineProperty(exports, "wrap", {
  enumerable: true,
  get: function get() {
    return wrap_1.wrap;
  }
});

__exportStar(require("./types"), exports);

exports.Messages = __importStar(require("./messages"));

function wrapMultiple(types, inputs, wrapOptions) {
  var combinedType, wrappedTogether;
  return _regeneratorRuntime.wrap(function wrapMultiple$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          //just wrap the types in a tuple and defer to wrap()
          combinedType = {
            typeClass: "tuple",
            memberTypes: types
          };
          debug("wrapping multiple");
          return _context.delegateYield(wrap_1.wrap(combinedType, inputs, wrapOptions), "t0", 3);

        case 3:
          wrappedTogether = _context.t0;
          return _context.abrupt("return", wrappedTogether.value.map(function (_ref) {
            var value = _ref.value;
            return value;
          }));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.wrapMultiple = wrapMultiple; //note: turns on loose

function wrapForMethod(method, inputs, resolveOptions) {
  var wrapped;
  return _regeneratorRuntime.wrap(function wrapForMethod$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield(wrapForMethodRaw(method, inputs, resolveOptions, true), "t0", 1);

        case 1:
          wrapped = _context2.t0;
          return _context2.abrupt("return", wrappingToResolution(method, wrapped));

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

exports.wrapForMethod = wrapForMethod;

function wrappingToResolution(method, wrapped) {
  if (wrapped.length > 0 && wrapped[wrapped.length - 1].type.typeClass === "options") {
    //there's options
    var wrappedArguments = wrapped.slice(0, -1); //cut off options

    var options = wrapped[wrapped.length - 1].value;
    return {
      method: method,
      arguments: wrappedArguments,
      options: options
    };
  } else {
    //no options
    return {
      method: method,
      arguments: wrapped,
      options: {}
    };
  }
} //doesn't separate out options from arguments & doesn't turn on loose


function wrapForMethodRaw(method, inputs, _ref2) {
  var userDefinedTypes,
      allowOptions,
      loose,
      inputsWithOptions,
      orOneMore,
      _args3 = arguments;
  return _regeneratorRuntime.wrap(function wrapForMethodRaw$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          userDefinedTypes = _ref2.userDefinedTypes, allowOptions = _ref2.allowOptions;
          loose = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
          debug("wrapping for method");

          if (!(method.inputs.length === inputs.length)) {
            _context3.next = 9;
            break;
          }

          //no options case
          debug("no options");
          return _context3.delegateYield(wrapMultiple(method.inputs, inputs, {
            userDefinedTypes: userDefinedTypes,
            oldOptionsBehavior: true,
            loose: loose,
            name: "<arguments>"
          }), "t0", 6);

        case 6:
          return _context3.abrupt("return", _context3.t0);

        case 9:
          if (!(allowOptions && method.inputs.length === inputs.length - 1)) {
            _context3.next = 16;
            break;
          }

          //options case
          debug("options");
          inputsWithOptions = [].concat(_toConsumableArray(method.inputs), [{
            name: "<options>",
            type: {
              typeClass: "options"
            }
          }]);
          return _context3.delegateYield(wrapMultiple(inputsWithOptions, inputs, {
            userDefinedTypes: userDefinedTypes,
            oldOptionsBehavior: true,
            loose: loose,
            name: "<arguments>"
          }), "t1", 13);

        case 13:
          return _context3.abrupt("return", _context3.t1);

        case 16:
          //invalid length case
          orOneMore = allowOptions ? " (or ".concat(method.inputs.length + 1, " counting transaction options)") : "";
          throw new errors_1.TypeMismatchError({
            typeClass: "tuple",
            memberTypes: method.inputs
          }, inputs, "<arguments>", 5, "Incorrect number of arguments (expected ".concat(method.inputs.length).concat(orOneMore, ", got ").concat(inputs.length, ")"));

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function resolveAndWrap(methods, inputs, _ref3) {
  var userDefinedTypes, allowOptions, possibleMatches, possibleMatchesWithOptions, possibleOptions, lastInput, isOptionsPossible, wrappedOptions, method, _method, resolutions, _iterator, _step, _method3, _wrapped, _resolutions$, _method2, wrapped;

  return _regeneratorRuntime.wrap(function resolveAndWrap$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          userDefinedTypes = _ref3.userDefinedTypes, allowOptions = _ref3.allowOptions;

          if (!(methods.length === 1)) {
            _context4.next = 4;
            break;
          }

          return _context4.delegateYield(wrapForMethod(methods[0], inputs, {
            userDefinedTypes: userDefinedTypes,
            allowOptions: allowOptions
          }), "t0", 3);

        case 3:
          return _context4.abrupt("return", _context4.t0);

        case 4:
          //OK, so, there are multiple possibilities then.  let's try to filter things down by length.
          possibleMatches = methods.filter(function (method) {
            return method.inputs.length === inputs.length;
          }); //but, we've also got to account for the possibility of options

          possibleMatchesWithOptions = [];
          possibleOptions = {};

          if (!(allowOptions && inputs.length > 0)) {
            _context4.next = 24;
            break;
          }

          //if options are allowed, we'll have to account for that.
          //*however*, in order to minimize the number of possibilities, we won't
          //use these unless the last argument of inputs actually looks like an options!
          lastInput = inputs[inputs.length - 1];
          isOptionsPossible = true;
          _context4.prev = 10;
          return _context4.delegateYield(wrap_1.wrap({
            typeClass: "options"
          }, lastInput, {
            name: "<options>",
            loose: true,
            oldOptionsBehavior: true,
            userDefinedTypes: userDefinedTypes
          }), "t1", 12);

        case 12:
          wrappedOptions = _context4.t1;
          possibleOptions = wrappedOptions.value;
          _context4.next = 23;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t2 = _context4["catch"](10);

          if (!(_context4.t2 instanceof errors_1.TypeMismatchError)) {
            _context4.next = 22;
            break;
          }

          isOptionsPossible = false;
          _context4.next = 23;
          break;

        case 22:
          throw _context4.t2;

        case 23:
          if (isOptionsPossible) {
            possibleMatchesWithOptions = methods.filter(function (method) {
              return method.inputs.length === inputs.length - 1;
            });
          }

        case 24:
          debug("possibleMatches: %o", possibleMatches);
          debug("possibleMatchesWithOptions: %o", possibleMatchesWithOptions); //if there's now only one possibility, great!

          if (!(possibleMatches.length === 1 && possibleMatchesWithOptions.length === 0)) {
            _context4.next = 36;
            break;
          }

          //only one possibility, no options. we can just defer to wrapMultiple.
          //(again, point is to have good error messaging)
          debug("only one possibility, no options");
          method = possibleMatches[0];
          _context4.t3 = method;
          return _context4.delegateYield(wrapMultiple(method.inputs, inputs, {
            userDefinedTypes: userDefinedTypes,
            loose: true,
            name: "<arguments>"
          }), "t4", 31);

        case 31:
          _context4.t5 = _context4.t4;
          _context4.t6 = {};
          return _context4.abrupt("return", {
            method: _context4.t3,
            arguments: _context4.t5,
            options: _context4.t6
          });

        case 36:
          if (!(possibleMatchesWithOptions.length === 1 && possibleMatches.length === 0)) {
            _context4.next = 46;
            break;
          }

          //only one possibility, with options.  moreover, we already determined the options
          //above, so we can once again just defer to wrapMultiple
          debug("only one possiblity, with options");
          _method = possibleMatchesWithOptions[0];
          _context4.t7 = _method;
          return _context4.delegateYield(wrapMultiple(_method.inputs, inputs, {
            userDefinedTypes: userDefinedTypes,
            loose: true,
            name: "<arguments>"
          }), "t8", 41);

        case 41:
          _context4.t9 = _context4.t8;
          _context4.t10 = possibleOptions;
          return _context4.abrupt("return", {
            method: _context4.t7,
            arguments: _context4.t9,
            options: _context4.t10
          });

        case 46:
          if (!(possibleMatches.length === 0 && possibleMatchesWithOptions.length === 0)) {
            _context4.next = 49;
            break;
          }

          debug("no possibilities"); //nothing matches!

          throw new errors_1.NoOverloadsMatchedError(methods, inputs, userDefinedTypes);

        case 49:
          //if all of our attempts to avoid it have failed, we'll have to actually use
          //our overload resolution system. note how we do *not* turn on loose in this
          //case!
          debug("attempting overload resolution");
          resolutions = [];
          _iterator = _createForOfIteratorHelper(methods);
          _context4.prev = 52;

          _iterator.s();

        case 54:
          if ((_step = _iterator.n()).done) {
            _context4.next = 71;
            break;
          }

          _method3 = _step.value;
          _wrapped = void 0;
          _context4.prev = 57;
          return _context4.delegateYield(wrapForMethodRaw(_method3, inputs, {
            userDefinedTypes: userDefinedTypes,
            allowOptions: allowOptions
          }), "t11", 59);

        case 59:
          _wrapped = _context4.t11;
          _context4.next = 67;
          break;

        case 62:
          _context4.prev = 62;
          _context4.t12 = _context4["catch"](57);
          //if there's an error, don't add it
          debug("failed: %O", _method3);
          debug("because: %O", _context4.t12);
          return _context4.abrupt("continue", 69);

        case 67:
          //note that options and arguments here are both not correct, but we'll
          //fix them up later!
          debug("adding: %O", _method3);
          resolutions.push({
            method: _method3,
            arguments: _wrapped,
            options: {}
          });

        case 69:
          _context4.next = 54;
          break;

        case 71:
          _context4.next = 76;
          break;

        case 73:
          _context4.prev = 73;
          _context4.t13 = _context4["catch"](52);

          _iterator.e(_context4.t13);

        case 76:
          _context4.prev = 76;

          _iterator.f();

          return _context4.finish(76);

        case 79:
          //now: narrow it down to the most specific one(s)
          debug("resolutions: %O", resolutions);
          resolutions = resolutions.filter(function (resolution) {
            return resolutions.every(function (comparisonResolution) {
              return !priority_1.isMoreSpecificMultiple(comparisonResolution.arguments, resolution.arguments, userDefinedTypes) || //because the comparison is nonstrict, this comparison is added to
              //effectively make it strict
              // i.e. we have !(x<=y) but we want !(x<y), i.e.,
              // !(x<=y) | x=y, i.e., !(x<=y) | (x<=y & y<=x),
              // i.e., !(x<=y) | y<=x
              priority_1.isMoreSpecificMultiple(resolution.arguments, comparisonResolution.arguments, userDefinedTypes);
            });
          });
          debug("resolutions remaining: %O", resolutions);
          _context4.t14 = resolutions.length;
          _context4.next = _context4.t14 === 0 ? 85 : _context4.t14 === 1 ? 86 : 88;
          break;

        case 85:
          throw new errors_1.NoOverloadsMatchedError(methods, inputs, userDefinedTypes);

        case 86:
          //there was a most specific resolution; fix up options and arguments
          //before returning
          _resolutions$ = resolutions[0], _method2 = _resolutions$.method, wrapped = _resolutions$.arguments;
          return _context4.abrupt("return", wrappingToResolution(_method2, wrapped));

        case 88:
          throw new errors_1.NoUniqueBestOverloadError(resolutions);

        case 89:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[10, 16], [52, 73, 76, 79], [57, 62]]);
}

exports.resolveAndWrap = resolveAndWrap;